export const normal = 'normal'
export const pre = 'pre'
export const preLine = 'pre-line'
export const preWrap = 'pre-wrap'
export const noWrap = 'nowrap'

export const whiteSpaces = [normal, pre, preLine, preWrap, noWrap]
